module.exports = __webpack_public_path__ + "img/brand (9).d11a8726.svg";